import React, { useEffect, useState } from 'react';
import { useSiteSettings } from '../../hooks/useSiteSettings';

// ============================================================
// WATERMARK —
//  • CLICK: thulo zoom hunchha (3 second), ani feri same size
//  • POSITION AUTO-CYCLE: harek 3 minute ma position badalchha —
//    तल (bottom-right) → center → top-right → top-left → ...
//    Sabai watermark instance synced (shared timer)
// ============================================================

const ZOOM_MS = 3000;               // click zoom duration
const CYCLE_MS = 3 * 60 * 1000;     // position change — 3 minutes
const POSITIONS = ['bottom-right', 'center', 'top-right', 'top-left'];

// Shared singleton cycle — sabai watermark ekai choti ma ghumnchha
let sharedIndex = 0;
let cycleTimer = null;
const listeners = new Set();

function startCycle() {
  if (cycleTimer) return;
  cycleTimer = setInterval(() => {
    sharedIndex = (sharedIndex + 1) % POSITIONS.length;
    listeners.forEach((fn) => fn(sharedIndex));
  }, CYCLE_MS);
}

function stopCycleIfIdle() {
  if (listeners.size === 0 && cycleTimer) {
    clearInterval(cycleTimer);
    cycleTimer = null;
  }
}

function Watermark({ position, size = 26, opacity = 0.65 }) {
  const siteSettings = useSiteSettings() || {};
  const logo = siteSettings.watermark_logo || siteSettings.mininav_logo || siteSettings.header_logo;

  // Auto-cycle position (position prop diyema fixed)
  const [autoIdx, setAutoIdx] = useState(sharedIndex);
  // Click zoom state
  const [zoomed, setZoomed] = useState(false);

  useEffect(() => {
    const fn = (i) => setAutoIdx(i);
    listeners.add(fn);
    startCycle();
    return () => {
      listeners.delete(fn);
      stopCycleIfIdle();
    };
  }, []);

  // 3 second pachhi zoom auto-normalize
  useEffect(() => {
    if (!zoomed) return undefined;
    const t = setTimeout(() => setZoomed(false), ZOOM_MS);
    return () => clearTimeout(t);
  }, [zoomed]);

  if (!logo) return null;

  const effective = position || POSITIONS[autoIdx];

  const posCls = {
    'bottom-right': 'bottom-1.5 right-1.5',
    'top-right': 'top-1.5 right-1.5',
    'bottom-left': 'bottom-1.5 left-1.5',
    'top-left': 'top-1.5 left-1.5',
    // Photo/reel ko exact center — translate-based (kunai pani size ma kaam garchha)
    'center': 'top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
  }[effective] || 'bottom-1.5 right-1.5';

  return (
    <img
      src={logo}
      alt=""
      aria-hidden="true"
      title="Kalo Jhola"
      onClick={(e) => {
        // Reel play/pause ra photo slider lai trigger hunu dinna
        e.stopPropagation();
        setZoomed(true);
      }}
      className={`absolute ${posCls} ${zoomed ? 'scale-[2]' : 'scale-100'} transition-transform ease-out pointer-events-auto select-none cursor-pointer z-[3]`}
      style={{
        height: size,
        width: 'auto',
        opacity: zoomed ? Math.min(1, opacity + 0.25) : opacity,
        transitionProperty: 'transform, opacity',
        transitionDuration: zoomed ? '400ms' : '900ms',
        transitionTimingFunction: 'cubic-bezier(0.22, 1, 0.36, 1)',
      }}
    />
  );
}

export default Watermark;
